import React from 'react';
import { Container, Title } from './styles';

const StepSectionWrapper = ({ children, title, dataPubli = '' }) => {
  return (
    <Container data-publi={dataPubli}>
      <Title data-publi={`${dataPubli}-title`}>{title}</Title>
      {children}
    </Container>
  );
};

export default StepSectionWrapper;
